/* eslint-disable dot-notation */
import React, { useEffect, useState } from 'react';
import uniqueId from 'lodash/uniqueId';

import KrService from '../services/kr.service';
import EmptyComment from './EmptyComment';
import CommentCountComp from './CommentCountComp';
import CommentAccessComp from './CommentAceessComp';
import RenderComment from './RenderComment';
import CkEditorComp from './CkEditorComp';

import './style.scss';

const krService = new KrService();

const OkrComment = ({ goalId }: any) => {
    const [comments, setComment] = useState([]);
    const [cmtLoaded, setCmtLoaded] = useState(false);
    let emoji = {
        symbols: [],
        hands: [],
        ppl: []
    };
    let cmtCount = 0;
    const getGoalComments = (p: any = {}) => {
        const contentId = document.getElementById('content');
        showLoaderWidget(contentId);
        krService.getGoalComments(p)
            .then((response) => {
                setComment(response.data.data);
                setCmtLoaded(true);
                removeLoader();
            })
            .catch((err: any) => {
                removeLoader();
                console.log('err', err);
            });
    }

    useEffect(() => {
        const params = { goalId, isCoManagerEliteSubscription: 1, json: true };
        getGoalComments(params)
    }, []);

    const comentActions = (cmtObj) => {
        if (cmtObj.action == 'delete') {
            const goalComments = comments['goalComments'].filter(c => c.id != cmtObj.id);
            comments['goalComments'] = goalComments;

            comments['goalCommentCount'] -= 1;
            const comment = Object.assign([], comments);
            setComment(comment);
        } else if (cmtObj.action == 'edit') {
            const rows = comments['goalComments'].map((g) => {
                if (g.id == cmtObj.id) {
                    g.comment = cmtObj.object.comment
                }
                return g;
            });
            comments['goalComments'] = rows;
            const comment = Object.assign([], comments);
            setComment(comment);
        } else if (cmtObj.action == 'add') {
            comments['goalComments'].unshift(cmtObj.object);
            comments['goalCommentCount'] += 1;
            const comment = Object.assign([], comments);
            setComment(comment);
        }
    }

    if (comments != undefined) {
        emoji = {
            symbols: comments['emojiSymbolConstants'],
            hands: comments['emojiHandConstants'],
            ppl: comments['emojiPplConstants']
        }
        cmtCount = comments['goalCommentCount'];
    }

    return (
        <div className="cmt-comments-wrapper">
            <div className="cmt-header-wrapper">
                <CommentCountComp count={cmtCount} />
                <CommentAccessComp />
            </div>
            { goalId
                && (
                    <CkEditorComp
                        goalId={goalId}
                        comentId={null}
                        comentActions={comentActions}
                        activeEditor={undefined}
                        focusEditor={undefined}
                        comment={undefined}
                        resetActiveEditor={undefined}
                    />
                )}
            <div
                className="cmt-list-wrap"
                role="list"
                aria-label="
                    Comments. Use tab to focus each comment, next tab will take you into the comment edit options
                "
            >
                {
                    comments != undefined
                        && comments['goalComments']
                        && comments['goalComments'].map((items) => (
                            <RenderComment key={uniqueId()} {...items} emoji={emoji} comentActions={comentActions} />
                        ))
                }
                {
                    cmtCount == 0
                        && cmtLoaded == true
                        && (
                            <EmptyComment
                                isCoManagerEliteSubscription={undefined}
                                teamOwnerId={undefined}
                                currentUserId={undefined}
                                goals={undefined}
                                {...comments}
                            />
                        )
                }
            </div>
        </div>
    )
}

export default OkrComment;
